import {
    Extensions,
    createNode,
} from '@baidu/realtime-editor';

import {Comp, InlineComp} from './render';
import Icon from './render/icon.svg?tsx';

export interface IErrorLocate {
    filter: {
        docId: string;
        userId: string;
        startDate: number;
        endDate: number;
    };
    isSaved: boolean;
}

const Extension = Extensions.createViewNode({
    type: 'error-locate',
    render: {
        renderView: Comp,
        renderStaticView: InlineComp,
    },
});

export default Extensions.createCardPlugin({
    nodes: [Extension],
    insert: {
        title: 'Ku前端问题定位',
        group: 'general',
        keywords: ['qdwtdw', 'Ku前端问题定位', 'kuqianduanwentidingwei'],
        onInsert: () => createNode({type: 'error-locate', data: ''}, [{text: '点击 Run 获取数据，文档 id 和用户 uuap 需至少填写一个'}]),
        icon: Icon,
    },
});
